import React from 'react';
import {
    Box,
    Skeleton,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Card,
    CardContent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function ItemViewSkeleton() {
    const theme = useTheme();

    return (
        <Box sx={{ mb: 1 }}>
            {/* Top section: icon, name and type skeleton */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Skeleton 
                    variant="rounded" 
                    width={48} 
                    height={48} 
                    sx={{ marginRight: 2, borderRadius: 2 }}
                />
                <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="60%" height={24} sx={{ mb: 0.5 }} />
                    <Skeleton variant="text" width="40%" height={20} />
                </Box>
            </Box>

            {/* Stats table skeleton */}
            <Table size="small" sx={{ mb: 2 }}>
                <TableBody>
                    {[1, 2, 3].map((idx) => (
                        <TableRow key={idx} sx={{ '& td': { borderBottom: 'none', py: 0.75 } }}>
                            <TableCell sx={{ width: '70%', verticalAlign: 'top', pl: 0 }}>
                                <Skeleton variant="text" width="80%" />
                            </TableCell>
                            <TableCell align="right" sx={{ width: '30%', pr: 0 }}>
                                <Skeleton variant="text" width="60%" sx={{ ml: 'auto' }} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {/* Description skeleton */}
            <Card
                variant="outlined"
                sx={{
                    boxShadow: 'none',
                    backgroundColor: theme.palette.grey[100],
                }}
            >
                <CardContent sx={{ p: 1 }}>
                    <Box>
                        <Skeleton variant="text" width="100%" />
                        <Skeleton variant="text" width="85%" />
                        <Skeleton variant="text" width="75%" />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}